import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from 'styled-jsx/css';
import useOnScreen from '@lmig/dotcom-aspect-hooks/useOnScreen';
import IconWrapper from '@lmig/lmds-react/icons/IconWrapper';

const defaultIconSize = '32';

const IconLoading = ({
  size = defaultIconSize,
  className = '',
  onInView = () => { },
  ariaHidden = false,
  id,
  label,
  title,
  color }) => {
  const iconRef = useRef();
  const inView = useOnScreen(iconRef, { onlyOnce: true });

  useEffect(() => {
    if (iconRef.current && inView) {
      onInView();
    }
  }, [inView, onInView]);

  const { className: hideLoadingClass, styles: hideLoadingStyles } = css.resolve`
    .lm-Icon-Loading {
      position: absolute;
    }
  `;
  const svgSize = typeof size === 'object' && size.base ? size.base : defaultIconSize;

  return (
    <>
      <IconWrapper
        size={size}
        id={id}
        label={label}
        title={title}
        color={color}
        className={cx(className, 'lm-Icon lm-Icon-Loading', hideLoadingClass)}
      >
        <svg
          ref={iconRef}
          aria-hidden={ariaHidden}
          width={svgSize}
          height={svgSize}
          xmlns="http://www.w3.org/2000/svg"
          focusable="false"
          aria-label="Loading..."
          role="img"
          viewBox={`0 0 ${svgSize} ${svgSize}`}
        >
          <title>Loading...</title>
        </svg>
      </IconWrapper>
      {hideLoadingStyles}
    </>
  );
};

IconLoading.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  onInView: PropTypes.func,
  ariaHidden: PropTypes.bool,
};

export default IconLoading;
